export default "__VITE_ASSET__CFVqheTt__"